var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.075 0C12.7471 0 15.3097 1.06391 17.1991 2.95768C19.0885 4.85146 20.15 7.41996 20.15 10.0982C20.15 14.3653 17.1585 19.0156 11.253 24.0989C10.9246 24.3816 10.506 24.5369 10.0731 24.5365C9.64017 24.5361 9.22178 24.3801 8.8939 24.0968L8.5033 23.7571C2.85923 18.8064 0 14.27 0 10.0982C0 7.41996 1.06147 4.85146 2.9509 2.95768C4.84033 1.06391 7.40294 0 10.075 0ZM10.075 6.21425C9.04729 6.21425 8.06166 6.62345 7.33496 7.35182C6.60826 8.0802 6.2 9.06809 6.2 10.0982C6.2 11.1282 6.60826 12.1161 7.33496 12.8445C8.06166 13.5729 9.04729 13.9821 10.075 13.9821C11.1027 13.9821 12.0883 13.5729 12.815 12.8445C13.5417 12.1161 13.95 11.1282 13.95 10.0982C13.95 9.06809 13.5417 8.0802 12.815 7.35182C12.0883 6.62345 11.1027 6.21425 10.075 6.21425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.125183c4514a2cf2a8bea73dea1dc0bd.svg";
export { ForwardRef as ReactComponent };